import { useContext, useMemo } from 'react';
import type { HeaderContext } from '@tanstack/react-table';
import type { ProjectClips } from '@trinity/chat/types';
import { ProjectClipsFiltersContext } from '../../contexts/project-clips/Context';
import { FilterableHeader } from './FilterableHeader';
import { SourceFilterMenu } from './SourceFilterMenu';

type Props = HeaderContext<ProjectClips.Item, unknown>;

export const SourceHeader = ({ column }: Props) => {
  const filters = useContext(ProjectClipsFiltersContext);
  const isFilterActive = useMemo(() => !!filters.transcriptIds.length, [filters.transcriptIds]);

  return (
    <FilterableHeader
      columnId={column.id}
      filterMenu={(onClose) => <SourceFilterMenu onSubmit={onClose} />}
      isFilterActive={isFilterActive}
    >
      Interview
    </FilterableHeader>
  );
};

SourceHeader.displayName = 'ProjectClips.SourceHeader';
